export default "__VITE_ASSET__BnOP0bwA__"